export default __webpack_public_path__ + "static/media/thumbup.6eca3a6c.svg";